import { createFileRoute } from '@tanstack/react-router'
import { requireRole } from '@/lib/auth-guards'
import { ApiTokensPage } from '@/features/admin/api-tokens'

export const Route = createFileRoute('/_authenticated/tokens/')({
  component: ApiTokensPage,
  beforeLoad: requireRole(['admin']),
})
